import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';

@Component({
  selector: 'app-shared-claim-document-link-form',
  templateUrl: './shared-claim-document-link-form.component.html',
  styleUrls: ['./shared-claim-document-link-form.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]]
    }
  ]
})
export class SharedClaimDocumentLinkFormComponent implements OnInit {

  constructor(private uiNotification: UiNotificationService) { }

  @Input() form!: UntypedFormGroup;
  @Input() readonlyFields = false;
  @Input() editMode = false;
  @Input() sharedDocumentLink = '';
  @Input() pinCode = '';

  ngOnInit(): void {
    if (!this.form) {
      throw new Error('SharedClaimDocumentLinkFormComponent requires a form input.');
    }
  }

  copyLink(): void {
    this.uiNotification.showSuccess('operations.copiedToClibpboard');
  }

}
